<app-header></app-header>
<div class="welcome_section text-center">
    <h1>Welcome to <br class="visible-xs" />Family Central</h1>
    <p style="padding-top: 20px;">Inorder to continue Please verify your account by clicking on the link sent that has
        been sent to your Email.</p>
</div>
<div class="form-group" style="text-align: center;">
    <a id="link-forgot" (click)="gotoDashBoard()" class="forgot_pass">Click here to go to DashBoard after email
        verification</a>
</div>